<template>
  <eagle-list
    :list-key="listKey"
  ></eagle-list>
</template>

<script lang="babel" type="text/babel">
import listMixin from '@/components/list/mixins/listMixin'
import listConfig from './fileListConfig'
export default {
  mixins: [listMixin],
  data: () => ({
    listKey: 'file-list',
    meta: {},
  }),
  methods: {
    async beforeIndex() {
      await Promise.all([])
    },
    async indexApi(params) {
      return await this.$api.collection.fileApi.index(params)
    },
    async patchApi(value, row, config) {
      const target = row.id
      const column = config.key
      return await this.$api.collection.fileApi.patch(target, column, value)
    },
    async deleteApi(target) {
      return await this.$api.collection.fileApi.delete(target)
    },
    async batchApi(targets, column, value) {
      return await this.$api.collection.fileApi.batch(targets, column, value)
    },
    async batchDeleteApi(targets) {
      return await this.$api.collection.fileApi.batchDelete(targets)
    },
    getListConfig() {
      return listConfig
    },
  },
  computed: {
    fileBaseUrl() {
      return this.$store.getters['base/fileBaseUrl']
    },
  },
}
</script>

<style lang="sass" type="text/sass" scoped></style>
